<template>
  <div class="page-container">
    <div class="artist-hd">
      <div class="blockquote">
        下一个艺术大师就是你
      </div>
      <div class="arrow-dowm"></div>
      <el-button type="success" class="renzheng" @click="collect" plain>立即认证</el-button>
    </div>
    <div class="artist-bd">
      <Artist :list="list"></Artist>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@font-face {
  font-family: "FontAwesome";
  src: url(../../assets/fonts/fontawesome-webfont.eot?v=4.1.0);
  src: url(../../assets/fonts/fontawesome-webfont.eot?#iefix&v=4.1.0)
      format("embedded-opentype"),
    url(../../assets/fonts/fontawesome-webfont.woff?v=4.1.0) format("woff"),
    url(../../assets/fonts/fontawesome-webfont.ttf?v=4.1.0) format("truetype"),
    url(../../assets/fonts/fontawesome-webfont.svg?v=4.1.0#fontawesomeregular)
      format("svg");
  font-weight: normal;
  font-style: normal;
}
.artist-hd {
  padding: 20px;
  text-align: center;
}
.blockquote {
  width: 328px;
  margin: 0 auto;
  text-align: center;
  margin: 15px auto;
  padding: 5px 15px 10px;
  font-size: 24px;
  position: relative;
}
.blockquote:before {
  position: absolute;
  left: 0;
  display: inline-block;
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  color: #c4c4c4;
  text-indent: 0;
  margin-top: -10px;
  content: "\f10d";
}

.blockquote::after {
  position: absolute;
  bottom: 0;
  right: 0;
  display: inline-block;
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  color: #c4c4c4;
  text-indent: 0;
  margin-bottom: -10px;
  content: "\f10e";
}

.arrow-dowm {
  text-align: center;
  font-size: 50px;
}

.arrow-dowm::before {
  display: inline-block;
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  content: "\f063";
}
.renzheng {
  display: inline-block;
  text-align: center;
}
</style>
<script>
import Artist from '../../components/artist.vue'
import {
  ArtistAPI
} from "../../model/artist.js";
let artistAPI = new ArtistAPI();
export default {
  name: 'index',
  data() {
    return {
      pageIndex: 1,
      pageSize: 50,
      list: []
    }
  },
  components: {
    Artist
  },
  created() {
    this.getAllArtist()
  },
  methods: {
    getAllArtist() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        artistAPI.allArtist({
          CustomerId: _this.user?_this.user.id:"",
          PageIndex: 1,
          PageSize: 50
        }).then((res) => {
          _this.list = res
          resolve();
        }, () => {
          reject();
        })
      })
    },
    collect() {
      let _this = this;
      _this.$router.push({ path: "/collect/index" })
    }
  }
}
</script>